import React, { useContext } from 'react';
import { cloneDeep } from 'lodash';
import { assign } from 'xstate';
import { Box, TextField } from '@mui/material';
import { StaticTimePicker, LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import deLocale from 'date-fns/locale/de';
import { IntlShape } from 'react-intl';

import { SendContext } from '../../SendContext';
import { BaseComponent } from '../Component';
import { MachineContext } from '../../MachineContext';
import { translateWithFallback } from '../../util';
import {EvoachButton} from "../Button";

export interface TimeInputComponent extends BaseComponent {
  type: 'timeInput';
  props: TimeInputProps;
}
export interface TimeInputProps {
  time: Date;
  buttonText: string;
  saveResultTo: string;
}
export const TimeInput: React.FC<TimeInputProps> = ({
  time,
  buttonText,
  saveResultTo,
}) => {
  const { send } = useContext(SendContext);
  const [date, setDate] = React.useState<Date | null>(new Date(time));
  return (
    <Box sx={{ width: '100%' }}>
      <LocalizationProvider dateAdapter={AdapterDateFns} locale={deLocale}>
        <StaticTimePicker
          value={date}
          onChange={(newDate) => setDate(newDate)}
          renderInput={(params) => <TextField {...params} />}
        />
      </LocalizationProvider>

      <EvoachButton
        onClick={() => {
          send({
            type: 'writeToContext',
            payload: { [saveResultTo]: { value: date, type: 'time' } },
          });
          send({
            type: 'next',
          });
        }}
      >
        {buttonText}
      </EvoachButton>
    </Box>
  );
};

export const renderTimeInputAction = (intl: IntlShape) => {
  return assign((context: MachineContext, _event, actionMetadata) => {
    const newContext = cloneDeep(context);
    newContext.widgetData = newContext.widgetData.filter(
      (element) => !element.temporary
    );
    newContext.widgetData.push({
      type: 'timeInput',
      temporary: actionMetadata.action.temporary ?? false,
      props: {
        time: actionMetadata.action.payload.time,
        buttonText: translateWithFallback(
          intl,
          actionMetadata.action.payload.buttonText
        ),
        saveResultTo: actionMetadata.action.payload.saveResultTo,
      },
    });
    return newContext;
  });
};
